import React, { Component } from 'react'
import withStyles from '@material-ui/core/styles/withStyles';
import Container from '@material-ui/core/Container';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogContentText from '@material-ui/core/DialogContentText';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Languages from '../components/supportedLanguages';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/Delete';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import { authMiddleWare } from '../util/auth';
import functionsApi from '../api';
import { languagesArray } from '../components/supportedLanguages';

const styles = (theme) => ({
    dialog: {
		margin: 100
	},
    addWorkoutContainer: {
        paddingRight:"30px",
        paddingRight:"30px"
    },
    content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	},
	floatingButton: {
		position: 'fixed',
		bottom: 30,
		right: 30
	},
    title: {
		marginLeft: theme.spacing(2),
		flex: 1
	},
    appBar: {
		position: 'inherit'
	},
    toolbar: theme.mixins.toolbar,
    submitButton: {
		display: 'block',
		color: 'white',
		textAlign: 'center',
		position: 'absolute',
		top: 14,
		right: 10
	},
    form: {
		margin: 13,
	},
    formControl: {
		minWidth: 120,
	},
    cardRoot: {
		maxWidth: 350,
		margin: 5,
	},
    gridListRoot: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		width: '100%',
		height: '100%',
	},
	cardMedia: {
		height: 350,
		width: 350,
		maxWidth: 350,
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
})
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class TrainingPlans extends Component {

	constructor(props) {
		super(props);

        this.state = {
			id: '',
			trainer: props.trainer.id,
            open: false,
            openSelectExerciseDialog: false,
			uiLoading: true,
            contents: [],
            supportedLang: [],
			buttonType: 'Create',
            workouts: [],
            exercises: [],
			publishedExercises: [], 
			errorOpen: false,
			error: ""
        }

		this.handleClickDeleteExercise = this.handleClickDeleteExercise.bind(this);
		this.handleEditClickOpen = this.handleEditClickOpen.bind(this);
    }

	isContentEmpty() {
		var found = false;
		for (const [index, value] of this.state.contents.entries()) {
			if (!value.title || !value.description) {
				found = true;
			}
		}
		return found
	}
    
    handleDurationChange = (event) => {
        this.setState({
            duration:event
        })
    }

    handleLanguageChange = (event) => {

		const items = []
		const supportedLang = []

		for (const [index, value] of event.entries()) {
			if (typeof this.state.contents[index] === 'undefined') {
				items.push({ id: index, language: value.code, languageDescription: value.label, title: value.title, description: value.description })
			} else {
				var title = this.state.contents[index].description
				var description = this.state.contents[index].description
				items.push({ id: index, language: value.code, languageDescription: value.label, title: title, description: description })
			}
			supportedLang.push(value.code)
		}

		this.setState({
			contents: items,
			supportedLang: supportedLang
		});
	};

    handleClickDeleteExercise = (exercise) => {

        var exercises = this.state.exercises

        const index = exercises.indexOf(exercise);
        if (index > -1) {
            exercises.splice(index, 1);
        }
        
        this.setState({
            exercises: exercises
        });
    };

	handleEditClickOpen(data) {
		this.setState({
			id: data.todo.id,
			isActive: data.todo.isActive,
			intensity: data.todo.intensity,
			contents: data.todo.contents,
			supportedLang: data.todo.supportedLang,
			viewCount: data.todo.viewCount,
			exercises: data.todo.exercises,
			buttonType: 'Edit',
			open: true,
			deleteOpen: false
		});
	}

    handleTitleChange = (event) => {
		var items = this.state.contents
		var item = items[event.target.id];

		item.title = event.target.value
		items[event.target.id] = item

		this.setState({
			contents: items
		});
	};

    handleDescriptionChange = (event) => {
		var items = this.state.contents
		var item = items[event.target.id];

		item.description = event.target.value
		items[event.target.id] = item

		this.setState({
			contents: items
		});
	};

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	handleClickDelete(data) {
		this.setState({
			deleteOpen: true,
			programToDelete: data
		});
	};

    componentWillMount = () => {
		authMiddleWare(this.props.history);

		functionsApi
			.get('/getAllProgramsByTrainer?trainerId=' + this.props.trainer.id)
			.then((response) => {
				this.setState({
					publishedExercises: response.data,
					uiLoading: true
				});
			})
			.catch((err) => {
				this.setState({errorOpen: true, error: "Could not load programs", uiLoading: false})
			});

		functionsApi
        .get('/getAllWorkouts')
        .then((response) => {
            console.log(response.data)
            this.setState({
                workouts: response.data,
                uiLoading: false
            });
        })
        .catch((err) => {
			this.setState({errorOpen: true, error: "Could not fetch workouts", uiLoading: false})
        });
	};

    render() {

		const handleClickOpen = () => {
			this.setState({
				id: '',
				isActive: '',
				buttonType: 'Create',
				trainer: this.props.trainer,
				intensity: '',
				open: true,
				exercises: [],
				contents: [],
				supportedLang: [],
				deleteOpen: false,
			});
		};
        
        const handleClose = () => {
            this.setState({ open: false });
        };

        const handleClickOpenSelectExerciseDialog = () => {
            this.setState({ openSelectExerciseDialog: true });
        };
        
        const handleCloseSelectExerciseDialog = () => {
            this.setState({ 
                openSelectExerciseDialog: false,
                exerciseSelected: null
             });
        };

        const handleExerciseSelectedChange = (event) => {
            this.setState({
                exerciseSelected: event.target.value
            })
        };

        const handleAddExercise = () => {
            var exercises = this.state.exercises
    
            exercises.push(this.state.exerciseSelected)
    
            this.setState({
                exercises: exercises,
                openSelectExerciseDialog: false,
                exerciseSelected: null
            })

        }

		const handleSubmit = async (event) => {
			authMiddleWare(this.props.history);
			event.preventDefault();

			this.setState({ uiLoading: true });

			const program = {
				id: this.state.id,
				supportedLang: this.state.supportedLang,
				contents: this.state.contents,
				intensity: this.state.intensity,
				exercises: this.state.exercises,
				trainer: this.state.trainer.id
			};

			let options = {};

			if (this.state.buttonType === 'Edit') {
				options = {
					url: `/editProgram/${program.id}`,
					method: 'put',
					data: program
				};
			} else {
				options = {
					url: '/postProgram',
					method: 'post',
					data: program
				};
			}

			functionsApi(options)
			.then(() => {
				this.setState({ open: false });
				window.location.reload();
			})
			.catch((error) => {
				this.setState({errorOpen: true, error: "There was an error", uiLoading: false})
			});
		}

		const handleCloseDelete = (event) => {
			this.setState({ deleteOpen: false });
		};

		const handleClickDelete = () => {
			this.setState({
				deleteOpen: false
			});

			authMiddleWare(this.props.history);
			functionsApi
				.delete(`/deleteProgram/${this.state.programToDelete.todo.id}`)
				.then(() => {
					window.location.reload();
				})
				.catch((err) => {
					this.setState({errorOpen: true, error: "There was an error deleting this program", uiLoading: false})
				});
		};

        const { classes } = this.props;
        const { open, openSelectExerciseDialog, exerciseSelected, deleteOpen, errorOpen, error } = this.state;

		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress className={classes.uiProgess} />}
				</main>
			);
		} else {
            return ( 
				<main className={classes.content}>
					<Snackbar open={errorOpen}>
						<Alert severity="error">
						{error}
						</Alert>
					</Snackbar>
					<div className={classes.toolbar} />
						
						<Dialog className={classes.dialog} fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
							<AppBar className={classes.appBar}>
								<Toolbar>
									<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
										<CloseIcon />
									</IconButton>
									<Typography variant="h6" className={classes.title}>
										{this.state.buttonType === 'Edit' ? 'Edit' : 'Create'}
									</Typography>
									<Grid container spacing={2} className={classes.switchGrid}>
									<Button
										autoFocus
										color="inherit"
										onClick={handleSubmit}
										className={classes.submitButton}
										disabled={
											!this.state.intensity ||
											(!this.state.supportedLang || this.state.supportedLang.length <= 0) ||
											(!this.state.contents || this.state.contents.length <= 0) ||
											this.state.exercises.length <= 0 ||
											this.isContentEmpty()
										}
									>
										{this.state.buttonType === 'Edit' ? 'Save' : 'Publish'}
									</Button>
									</Grid>	
								</Toolbar>
							</AppBar>

							<form className={classes.form} noValidate>
								<Grid container spacing={2}>
									<Grid item md={6} xs={12}>
										<FormControl fullWidth variant="outlined" className={classes.formControl}>
											<InputLabel id="intensity">Intensity</InputLabel>
											<Select
												labelId="intensity"
												id="intensity"
												name="intensity"
												onChange={this.handleChange}
												label="intensity"
												autoWidth
												value={this.state.intensity}
											>
												<MenuItem value="">
													<em>None</em>
												</MenuItem>
												<MenuItem value={"beginner"}>Beginner</MenuItem>
												<MenuItem value={"intermediate"}>Intermediate</MenuItem>
												<MenuItem value={"advanced"}>Advanced</MenuItem>
											</Select>
										</FormControl>
									</Grid>
									<Grid item md={6} xs={12}>
										<Languages
											variant="outlined"
											required
											fullWidth
											id="supportedLang"
											label="Select the languages for your workout"
											name="supportedLang"
											autoComplete="supportedLang"
											items={this.state.supportedLang.flatMap((code) => languagesArray.filter(obj => {
												return obj.code === code
											}))}
											onChange={this.handleLanguageChange}
										/>
									</Grid>

									<div className={classes.gridListRoot}>

										{this.state.contents.map((content) => (
											<Card md={12} className={classes.cardRoot}>
												<CardContent>
													<Grid container spacing={2}>
														<Grid item xs={12}>
															<TextField
																variant="outlined"
																required
																fullWidth
																name={content.title}
																label={content.languageDescription + ' title'}
																type="contents"
																id={content.id}
																autoComplete="contents"
																value={content.title}
																onChange={this.handleTitleChange}
															/>
														</Grid>
														<Grid item xs={12}>
															<TextField
																variant="outlined"
																required
																fullWidth
																name={content.description}
																multiline
																rows={4}
																label={content.languageDescription + ' description'}
																type="contents"
																id={content.id}
																autoComplete="contents"
																value={content.description}
																onChange={this.handleDescriptionChange}
															/>
														</Grid>
													</Grid>
												</CardContent>
											</Card>
										))}
									</div>
									<Grid container alignItems="center" spacing={2}>
										<Grid item xs={12} >
											<Typography variant="body2" align="center" color="textSecondary">Exercises on plan</Typography>
										</Grid>
										<Grid item xs={12}>
											<List >
											{this.state.exercises.map((exercise, index) => (
												<ListItem>
												<ListItemAvatar>
												<Avatar>
													<FolderIcon />
												</Avatar>
												</ListItemAvatar>
												<ListItemText
												primary={exercise.contents[0].title}
												secondary={"day " + (index + 1)}
												/>
												<ListItemSecondaryAction>
												<IconButton edge="end" aria-label="delete" onClick={() => this.handleClickDeleteExercise(exercise)}>
													<DeleteIcon />
												</IconButton>
												</ListItemSecondaryAction>
											</ListItem>
											))}
											</List>
										</Grid>
										<Grid container alignItems="center" justify="flex-end" className={classes.addWorkoutContainer}>
											<Button variant="contained" onClick={handleClickOpenSelectExerciseDialog}>Add exercise</Button>
										</Grid>
									</Grid>
								</Grid>
							</form>
						</Dialog>

						<Dialog disableBackdropClick disableEscapeKeyDown open={openSelectExerciseDialog} onClose={handleCloseSelectExerciseDialog}>
							<DialogTitle>Select exercise</DialogTitle>
							<DialogContent>
							<form className={classes.container}>
								<FormControl className={classes.formControl}>
								<InputLabel id="demo-dialog-select-label">Exercise</InputLabel>
								<Select
									labelId="demo-dialog-select-label"
									id="demo-dialog-select"
									value={this.state.exerciseSelected}
									onChange={handleExerciseSelectedChange}
									input={<Input />}
								>
									{this.state.workouts.map((workout, index) => (
										<MenuItem value={workout}>{workout.contents[0].title}</MenuItem>
									))}
								</Select>
								</FormControl>
							</form>
							</DialogContent>
							<DialogActions>
							<Button onClick={handleCloseSelectExerciseDialog} color="primary">
								Cancel
							</Button>
							<Button onClick={handleAddExercise} disabled={this.state.exerciseSelected === undefined || this.state.exerciseSelected === null } color="primary">
								Ok
							</Button>
							</DialogActions>
						</Dialog>

						<Dialog
						open={deleteOpen}
						onClose={handleCloseDelete}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								Deleting a program will make it imediatelly unavaliable to the users and remove it completelly from the H&T plataform. Do you want to proceed?
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleCloseDelete} color="primary">
								Cancel
						</Button>
							<Button onClick={handleClickDelete} color="secondary" autoFocus>
								Delete
						</Button>
						</DialogActions>
					</Dialog>

					<div className={classes.gridListRoot}>
						<Grid container alignItems="center" justify="center" spacing={2}>
							{this.state.publishedExercises.map((workout, i) => (
								<Card className={classes.cardRoot} key={i}>
									<CardActionArea>
										<CardMedia
											className={classes.cardMedia}
											image={workout.exercises[0].videoThumbURL}
										/>
										<CardContent>
											<Typography noWrap variant="caption" color="textSecondary" >
												{workout.id}
											</Typography>
											<Typography gutterBottom variant="h6" component="h2">
												{workout.contents[0].title}
											</Typography>
											<Typography noWrap variant="body2" color="textSecondary" >
												{workout.exercises.length + " days | " + workout.intensity  + " | " + workout.style}
											</Typography>
											<Typography noWrap variant="body2" color="textSecondary" >
												{workout.contents[0].description}
											</Typography>
										</CardContent>
									</CardActionArea>
									<CardActions>
										<Button size="small" color="primary" onClick={() => this.handleEditClickOpen({ todo: workout })}>
											Edit
										</Button>
										<Button size="small" color="secondary" onClick={() => this.handleClickDelete({ todo: workout })}>
											Delete
										</Button>
									</CardActions>
								</Card>
							))}
						</Grid>
						<Fab variant="extended" className={classes.floatingButton} onClick={handleClickOpen}>
							<AddIcon className={classes.extendedIcon} />
							Add training
						</Fab>
					</div>
				</main>
        );}
    }
}

export default withStyles(styles)(TrainingPlans);